const state = {
 isLoading: false,
 activeApiCalls: 0,
};

const mutations = {
 INCREMENT_API_CALLS(state) {
  state.activeApiCalls++;
 },

 DECREMENT_API_CALLS(state) {
  state.activeApiCalls--;
 },

 RESET_API_CALLS(state) {
  state.activeApiCalls = 0;
  state.isLoading = false;
 },

 SET_IS_LOADING(state) {
  state.isLoading = state.activeApiCalls > 0;
 },
};

const actions = {
 setIsLoading({ commit }, value) {
  if (value) {
   commit("INCREMENT_API_CALLS");
  } else {
   commit("DECREMENT_API_CALLS");
  }

  commit("SET_IS_LOADING");
 },

 resetApiCalls({ commit }) {
  commit("RESET_API_CALLS");
 },
};

const getters = {
 isLoading(state) {
  return state.isLoading;
 },
};

export default {
 namespaced: false,
 state,
 mutations,
 actions,
 getters,
};
